// Design tokens — NDS Bonus Management Module (spec §9.1).
// Light theme only. Plus Jakarta Sans (loaded in ManageBonus.css).

export const INK = '#0B1354'; // brand navy — headers, primary text, selected chips
export const BLUE = '#4A5BD9'; // indigo — ghost text, span gradient start, accents
export const BLUE_SOFT = '#EEF0FE'; // indigo soft — ghost fill, selected duration chip
export const GREEN = '#16A34A'; // active, all-day pill, switch on
export const RED = '#DC2626'; // inactive
export const AMBER = '#FFC93C'; // save pill, "+" button, midnight tick
export const CANVAS = '#F4F5FA'; // screen background, inner panel fills
export const LINE = '#E7E9F4'; // borders and dividers
export const MUTED = '#7A809B'; // labels, secondary text, unselected controls

export const CARD_SHADOW = '0 1px 2px rgba(11,19,84,0.06)';
export const FONT =
  "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";

// Monday-first, per spec.
export const DAYS_SHORT = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
export const DAYS_FULL = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];
export const DAYS_ABBR = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
export const ALL_DAYS = [0, 1, 2, 3, 4, 5, 6];
export const MON_SAT = [0, 1, 2, 3, 4, 5];
